import React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
// --- external imports ------

import { turnSelectors } from '../../../store';
import Asset from '../BaseAssets';
// --- internal imports ------

function NewspaperHeader(props) {
	return (
		<>
			<NewspaperTitle
				x={200}
				y={135}
				projection={{
					width: 170,
					height: 28
				}}
				fontSize={13}
				data-testid={`${props['data-testid-prefix']}-turn-date`}
			>
				{props.turnDate}
			</NewspaperTitle>
			<NewspaperTitle
				x={401}
				y={135}
				projection={{
					width: 240,
					height: 28
				}}
				fontSize={13}
			>
				SAMSTOWN
			</NewspaperTitle>
			<NewspaperTitle
				x={686}
				y={135}
				projection={{
					width: 200,
					height: 28
				}}
				fontSize={13}
			>
				TRADERS NEWSPAPER
			</NewspaperTitle>
			<NewspaperTitle
				x={927}
				y={135}
				projection={{
					width: 264,
					height: 28
				}}
				fontSize={13}
			>
				{props.displayDetails.header.sectionName}
			</NewspaperTitle>
			<NewspaperTitle
				x={1222}
				y={135}
				projection={{
					width: 19,
					height: 28
				}}
				fontSize={13}
			>
				{props.displayDetails.header.pageNo}
			</NewspaperTitle>
		</>
	);
};

const NewspaperTitle = styled(Asset.Text)`
	font-family: "KG Corner of the Sky";
	text-align: center;
	color: #1f261f;
	line-height: 2.15em;
`;

function mapStoreStateToProps(storeState) {
	return {
		turnDate: turnSelectors.getTurnDate(storeState),
	};
};

export default connect(mapStoreStateToProps)(NewspaperHeader);
